export const frCA = {
  ANSWER: {
    CARRIER: {
      "3PL": "3PL",
      BREAD: "PAIN",
      COKE: "COKE",
      DSD: "DSD",
      FLOWERS: "FLEURS",
      GFS: "GFS",
      LCL: "LCL",
      MEAT: "VIANDE",
      PEPSI: "PEPSI",
    },
    DRIVER_TYPE: {
      CONTRACTOR: "Entrepreneur",
      DELIVERY: "Livraison",
      FLEET_DRIVER: "Chauffeur de flotte",
      GULFSTREAM: "Gulfstream",
      MAINTENANCE: "Maintenance",
      PERSONAL_VEHICLE: "Véhicule personnel",
      SERVICE: "Service",
      SHUNT_DRIVER: "Chauffeur local",
      SHUTTLE_DRIVER: "Chauffeur de navette",
    },
    DUNNAGE: {
      "1_2": "1/2",
      "1_4": "1/4",
      FULL: "Plein",
    },
    ENTRY_PURPOSE: {
      BOBTAIL: "Camion sans remorque",
      CARRIER_LOADED: "Chargé par le transporteur",
      CONTRACTOR: "Entrepreneur",
      CONTRACTOR_VISITOR: "Entrepreneur/Visiteur",
      DELIVERY: "Livraison",
      DROP: "Dépôt",
      DROP_HOOK: "Dépôt et accrochage",
      EMPTY: "Vide",
      EMPTY_TRAILER: "Remorque vide",
      FOODBANK: "Banque alimentaire",
      FUEL: "Carburant",
      LIVE_LOAD: "Chargement en direct",
      LOADED: "Chargé",
      NFI_LOADED: "Chargé par NFI",
      OTHERS: "Autres",
      PARKING: "Stationnement",
      PICKUP_EMPTY: "Ramassage vide",
      PICKUP_LOAD: "Ramassage chargé",
      PICK_UP: "Ramassage",
      PLANT_LOADED: "Chargé à l’usine",
      PRIVATE: "Privé",
      REPAIR: "Réparation",
      VISITOR: "Visiteur",
      WAAS_FAAS: "WAAS/FAAS",
      WASH: "Lavage",
    },
    ENTRY_TYPE: {
      INBOUND: "Entrant",
      INBOUND_ARRIVAL: "Entrant / Arrivée",
      INBOUND_DROP: "Entrant / Dépôt",
      MAINTENANCE: "Maintenance",
      OUTBOUND: "Sortant",
      OUTBOUND_DEPARTURE: "Sortant / Départ",
      OUTBOUND_PICKUP: "Sortant / Ramassage",
      WALMART_CARRIERS: "Transporteurs Walmart",
      YARD_STORAGE: "Entreposage sur parc",
    },
    EQUIPMENT_LENGTH: {
      "20": "20",
      "40": "40",
      "48": "48",
      "53": "53",
    },
    EQUIPMENT_TYPE: {
      BOBTAIL: "Camion sans remorque",
      CHASSIS: "Châssis",
      CONTAINER: "Container",
      TRAILER: "Remorque",
      VAN: "Fourgonnette",
    },
    FUEL_LEVEL: {
      "1_2": "1/2",
      "1_4": "1/4",
      "1_8": "1/8",
      "3_4": "3/4",
      "3_8": "3/8",
      "5_8": "5/8",
      "7_8": "7/8",
      EMPTY: "Vide",
      FULL: "Plein",
    },
    GENERIC: {
      NO: "NON",
      YES: "OUI",
    },
    LOADED_STATUS: {
      EMPTY: "Vide",
      LOADED: "Chargé",
    },
    LOAD_DETAILS: {
      CONVERTER_1X: "CONVERTER_1X",
      CONVERTER_2X: "CONVERTER_2X",
      DRY: "SEC",
      FROZEN: "SURGELÉ",
      HEAT: "CHALEUR",
      "MULTI TEMP": "MULTI TEMP",
      REEFER: "CONTENEUR RÉFRIGÉRÉ",
    },
    LOAD_TYPE: {
      BOBTAIL: "Camion sans remorque",
      EMPTY: "Vide",
      LOADED: "Chargé",
      OTHERS: "Autres",
    },
    REEFER: {
      OFF: "Arrêt",
      ON: "Marche",
    },
    TRAILER_TYPE: {
      DRY: "Sec",
      REEFER: "Conteneur réfrigéré",
    },
    VISIT_TYPE: {
      DROP_AND_GO: "Dépôt sans attente",
      DROP_AND_WAIT: "Dépôt et attente",
      DROP_EMPTY: "Dépôt vide",
      PICKUP_EMPTY: "Ramassage vide",
    },
  },
  APP: {
    DEVELOPED_BY_EAIGLE: "Développé par EAIGLE",
    INVALID_FACILITY: "ÉTABLISSEMENT INTROUVABLE!",
    PAGE_NOT_FOUND: "Page introuvable. Paramètres non valides",
    PLEASE_ROTATE:
      "Veuillez mettre votre appareil en mode portrait pour utiliser cette application.",
    POWERED_BY_EAIGLE: "Propulsé par <LOGO/> eaigle.com",
  },
  AVAC: {
    ADD_COMMENT_HEADER: "Ajouter un commentaire (obligatoire)",
    AREA: {
      ISO: "ISO",
      TANK_WASH: "Lavage de camion citerne",
    },
    COMMENT_HERE: "Ajoutez votre commentaire ici...",
    COMMENT_SUBMITTED: "Commentaire envoyé",
    DETAILS: {
      ACTUAL_TEMPERATURE: "Température réelle",
      ADDITIONAL_COMMENTS: "Commentaires additionnels",
      ALLOCATED_PAD: "AIRE DE STATIONNEMENT attribuée",
      APPOINTMENT_INFORMATION: "Informations sur le rendez-vous",
      APPOINTMENT_NUMBER: "Numéro de rendez-vous",
      APPOINTMENT_TIME: "Heure du rendez-vous",
      APPOINTMENT_TYPE: "Type de rendez-vous",
      AVAC_EVENT: "Événement AVAC",
      BOL_NUMBER: "Numéro de connaissement",
      BOOKING_NUMBER: "Numéro de réservation",
      BRE_STATUS: "Statut BRE",
      BROKER: "Courtier",
      CARRIER: "Transporteur",
      CARRIER_NAME: "Nom du transporteur",
      CHASSIS_NUMBER: "Numéro de châssis",
      CHILD_SCAC: "SCAC enfant",
      COMMENT: "Commentaire",
      CVIP_DATE: "Date CVIP",
      CV_DETAILS: "Détails CV",
      CV_EVENT_ID: "Identifiant d’événement CV",
      DELIVERY_NOTE: "Bon de livraison",
      DESCRIPTION: "Description",
      DRIVER_ENGAGEMENT_TIME: "Durée d’engagement du chauffeur (sec)",
      DRIVER_INFORMATION: "Informations sur le chauffeur",
      DRIVER_NAME: "Nom du chauffeur",
      DUNNAGE: "Cales",
      ENTRY_SUBTYPE: "Sous-type d’entrée",
      ENTRY_TYPE: "Type d’entrée",
      EQUIPMENT_LENGTH: "Longueur de l’équipement",
      EQUIPMENT_LOADED_STATUS: "Statut de chargement de l’équipement",
      EQUIPMENT_TYPE: "Type d’équipement",
      EQUIPMENT_TYPE_ID: "Identifiant du type d’équipement",
      EVENT_ID: "Identifiant de l’événement",
      EVENT_INFORMATION: "Informations sur l’événement",
      EVENT_TIME: "Heure de l’événement",
      EVENT_TYPE: "Type d’événement",
      FAILURE_REASON: "Raison de l’échec",
      FIRST_NAME: "Prénom",
      FUEL_LEVEL: "Niveau de carburant",
      GATE_ENGAGEMENT_TIME: "Durée d’engagement de la barrière (sec)",
      ID: "Identifiant",
      IMAGES: "Images",
      LANE_ID: "Identifiant de la voie",
      LANE_NAME: "Nom de la voie",
      LAST_NAME: "Nom de famille",
      LIVE_DROP: "Dépôt en direct",
      LOAD_ID: "Identifiant du chargement",
      LTL: "LTL",
      MC_NUMBER: "Numéro de transporteur",
      OPERATOR_COMMENTS: "Commentaires de l’opérateur",
      ORDER_NUMBER: "Numéro de commande",
      PARENT_SCAC: "SCAC parent",
      PHONE_NUMBER: "Numéro de téléphone",
      PLATE_NUMBER: "Numéro d’immatriculation",
      PO: "Bon de commande",
      PO_LOAD_DETAILS: "Détails Charge / Bon de commande",
      PO_NUMBER: "Numéro de bon de commande",
      RAIL_CARS: "Wagons",
      REFERENCE_NUMBER: "Numéro de référence",
      SCAC: "SCAC",
      SEAL_NUMBER: "Numéro de scellé",
      SET_TEMPERATURE: "Température définie",
      SPOT_NUMBER: "Numéro Spot",
      START_TIME: "Heure de début",
      STATUS: "État d’avancement",
      TEMPERATURE: "Température",
      TIMESTAMP: "Horodatage",
      TRACTOR_ID: "ID du tracteur",
      TRACTOR_NUMBER: "Numéro du tracteur",
      TRAILER: "Remorque",
      TRAILER_NUMBER: "Numéro de la remorque",
      TRAILER_TYPE: "Type de remorque",
      TRUCK_INFORMATION: "Informations sur le camion",
      TRUCK_NUMBER: "Numéro du camion",
      UNIT: "Unité",
      UNIT_ID: "Identifiant de l’unité",
      UNIT_NUMBER: "Numéro de l’unité",
      UNIT_TYPE: "Type d’unité",
      USDOT_NUMBER: "Numéro USDOT",
      VEHICLE_MEDIA: "Supports du véhicule",
      VIDEOS: "Vidéos",
      WAC: "WAC",
      ZONE: "Zone",
    },
    DRIVER_ASSIST: "Assistance au chauffeur",
    DRIVER_CREATED: "Chauffeur créé avec succès!",
    DRIVER_PIN: "Code PIN chauffeur :",
    DRIVER_QR_CODE: "Code QR chauffeur",
    DRIVER_UPDATED: "Chauffeur mis à jour avec succès!",
    ERROR: {
      ACCESS_DENIED: "Accès refusé",
      ACCESS_DENIED_DETAILS: "Vous n’avez pas accès à ce module.",
      AUTH_ERROR: "Erreur d’authentification : {{ERROR}}",
      CONTACT_ADMIN:
        "Veuillez contacter votre administrateur pour obtenir l’autorisation.",
      ERROR_CREATING_DRIVER: "Une erreur s’est produite lors de la création du chauffeur",
      ERROR_UPDATING_DRIVER:
        "Une erreur s’est produite lors de la mise à jour du chauffeur",
      FAILED_TO_CREATE_DRIVER: "Échec de la création du chauffeur",
      FAILED_TO_FETCH_FACILITIES: "Échec de la récupération des établissements",
      FAILED_TO_UPDATE_DRIVER: "Échec de la mise à jour du chauffeur",
      LOADING_EVENT_DETAILS_AVAC:
        "Erreur lors du chargement des détails de l’événement. Redirection vers AVAC...",
      LOADING_EVENT_DETAILS_GATE_LOG:
        "Erreur lors du chargement des détails de l’événement. Redirection vers Gate Log...",
      MISSING_EMAIL_AND_PHONE_NUMBER:
        "Veuillez fournir une adresse courriel ou un numéro de téléphone",
      NO_FACILITY_SELECTED: "Aucun établissement sélectionné",
      WEBSOCKET_ERROR: "Erreur WebSocket: {{ERROR}}",
    },
    FACILITY: "Établissement",
    FAILED_EVENTS: "Événements ayant échoué",
    HISTORICAL_EVENTS: "Événements historiques (dernier jour)",
    IMAGE_MODAL_INSTRUCTIONS:
      "Faites défiler pour zoomer • Faites glisser pour déplacer l’image agrandie",
    NEW_DRIVER: {
      PIN_SENT:
        "Le code PIN a été envoyé à l’adresse courriel et au numéro de téléphone du chauffeur.",
      QR_CODE_AND_PIN_SENT:
        "Le code QR et le code PIN ont été envoyés à l’adresse courriel et au numéro de téléphone du chauffeur.",
      QR_CODE_SENT:
        "Le code QR a été envoyé à l’adresse courriel et au numéro de téléphone du chauffeur.",
    },
    NO_APPROVED_EVENTS: "Aucun événement approuvé dans la plage de dates sélectionnée",
    NO_EVENTS: "Aucun événement disponible",
    NO_FAILED_EVENTS: "Aucun événement ayant échoué au cours de la dernière journée",
    NO_INVENTORY: "Aucun article en stock trouvé.",
    NO_LANES: "Aucune voie disponible.",
    NO_MATCHES: "Aucune correspondance trouvée",
    NO_NON_FAILURE_EVENTS: "Aucun événement sans échec au cours de la dernière journée",
    NO_VEHICLE_MEDIA: "Aucun média véhicule disponible.",
    PRODUCT_NAME: "AVAC™",
    READ_AND_AGREE:
      "Veuillez lire et approuver le <BUTTON>formulaire de décharge</BUTTON>.",
    SELECT_LANE: "Sélectionnez une voie",
    SUBMITTING: "Envoi...",
    SUGGESTION: {
      EMAIL_OR_PHONE_NUMBER: "Remplir le champ de courriel ou de numéro de téléphone",
    },
    TOAST: {
      APPROVE_EVENT_FAILED: "Échec de l’approbation de l’événement. Veuillez réessayer.",
      EVENT_APPROVED:
        "Événement approuvé avec succès! Cliquez sur le bouton « Ouvrir la barrière ».",
      EVENT_REJECTED: "Événement rejeté.",
      GATE_OPENED: "Barrière ouverte avec succès!",
      OPEN_GATE_FAILED:
        "Échec de l’ouverture de la barrière. Veuillez réessayer ou contacter l’assistance.",
      REJECT_EVENT_FAILED: "Échec du rejet de l’événement. Veuillez réessayer.",
    },
    VALIDATING_ACCESS: "Validation de votre accès...",
    VALIDATION: {
      INVALID_EMAIL: "Veuillez saisir une adresse courriel valide",
      INVALID_NAME: "Ne doit contenir que des lettres et des espaces",
      INVALID_PHONE_NUMBER:
        "Veuillez saisir un numéro de téléphone valide à 10 chiffres.",
    },
  },
  BRE: {
    FAILED_TO_OPEN_GATE: "Échec d’ouverture de la barrière",
    GATE_OPEN_FAILED: "L’ouverture de la barrière a échoué",
    INVALID_APPOINTMENT: "Rendez-vous non valide",
    DRIVER_REGISTRATION_EXPIRED:
      "L’enregistrement du conducteur n’est pas valide. Veuillez communiquer avec l’opérateur de la barrière.",
    INVALID_QRCODE_FORMAT: "Format de code QR non valide",
    KRAFT: {
      APPOINTMENT_USAGE_EXCEEDED: "Dépassement de l’utilisation des rendez-vous",
      BOL_CALL_FAILED: "Échec de l’appel sur connaissement",
      BOL_CALL_FAILED_NO_LANE_EVENT:
        "Échec de l’appel sur connaissement ou CVLaneEvent introuvable",
      BOL_PO_MISSING:
        "Numéro de connaissement et/ou de bon de commande manquant dans le rendez-vous",
      BOL_PO_MISSING_NO_LANE_EVENT:
        "Numéro de connaissement et/ou de bon de commande manquant dans le rendez-vous et InProgress CVLaneEvent introuvable",
      CVLANE_EVENT_NOT_FOUND: "CVLaneEvent n’existe pas",
      EVENT_OUTSIDE_OPERATION_HOURS: "Événement en dehors des heures d’ouverture",
      FAILED_OBTAIN_BOL_INFO: "Échec de l’obtention des informations de connaissement",
      FUEL_LEVEL_BELOW_THRESHOLD:
        "Niveau de carburant inférieur à 0,75 et InProgress CVLaneEvent introuvable",
      FUEL_LEVEL_BELOW_THRESHOLD_NO_LANE_EVENT:
        "Niveau de carburant inférieur à 0,75 et InProgress CVLaneEvent introuvable",
      INTERNAL_FAILURE: "Défaillance interne",
      INVALID_APPOINTMENT_ENTRY_SUBTYPE: "Type de sous-entrée de rendez-vous non valide",
      INVALID_APPOINTMENT_ENTRY_TYPE: "Type d’entrée de rendez-vous non valide",
      INVALID_APPOINTMENT_QR_CODE: "Code QR de rendez-vous non valide",
      INVALID_ENTRY_SUBTYPE: "Type de sous-entrée non valide",
      INVALID_ENTRY_SUBTYPE_IN_APPOINTMENT:
        "Type de sous-entrée non valide dans le rendez-vous",
      INVALID_ENTRY_SUBTYPE_NO_LANE_EVENT:
        "Type de sous-entrée non valide dans le rendez-vous et InProgress CVLaneEvent introuvable",
      INVALID_INBOUND_BOBTAIL_PLATE_NUMBER:
        "Numéro d’immatriculation non valide pour un camion sans remorque entrant",
      INVALID_OUTBOUND_EMPTY_APPOINTMENT_USAGE:
        "Utilisation non valide d’un rendez-vous pour un camion vide sortant",
      INVALID_QRCODE_SOURCE: "Source du code QR non valide",
      MAX_APPOINTMENT_LIMIT_REACHED:
        "Limite maximale d’utilisation des rendez-vous atteinte",
      NO_CV_LANE_EVENT_FOUND_OR_UNSUPPORTED_APPOINTMENT_MISMATCH_USAGE:
        "Aucun CV LaneEvent trouvé ou utilisation non prise en charge pour une erreur de rendez-vous",
      NO_INPROGRESS_LANE_EVENT_FOUND: "Aucun InProgress LaneEvent trouvé",
      NO_INPROGRESS_LANE_EVENT_FOUND_OR_TRAILER_NUMBER_IS_PRESENT_IN_THE_RECORD:
        "Aucun InProgress LaneEvent trouvé ou numéro de remorque présent dans le dossier",
      NO_USER_INFO_RECEIVED: "Aucune information utilisateur reçue",
      NO_VEHICLE_DETECTED: "Aucun véhicule détecté ou type de véhicule non valide",
      NO_VEHICLE_DETECTED_BOBTAIL:
        "Aucun véhicule détecté ou ce véhicule n’est pas un camion sans remorque",
      PLEASE_PROCEED_TO_DOCK_OFFICE: "Veuillez vous rendre au bureau",
      SEAL_NUMBER_MISMATCH: "Le numéro de scellé ne correspond pas",
      SEAL_NUMBER_MISSING:
        "Le numéro de scellé est manquant pour un véhicule sortant chargé",
      TEMPERATURE_EXCEEDS_LIMIT: "La température dépasse la limite",
      TEMPERATURE_INFO_MISSING:
        "Les informations de température sont manquantes et, étant donné la saison actuelle, il n’est pas possible de contourner le contrôle de la température",
      TEMPERATURE_INFO_MISSING_NO_LANE_EVENT:
        "Les informations de température sont manquantes et, étant donné la saison actuelle, il n’est pas possible de contourner le contrôle de la température. InProgress CVLaneEvent introuvable",
      TEMPERATURE_INFO_NOT_INCLUDED:
        "Les informations de température n’étaient pas incluses dans le rendez-vous",
      TEMPERATURE_INFO_NOT_INCLUDED_NO_LANE_EVENT:
        "Les informations de température n’ont pas été ajoutées au rendez-vous et InProgress CVLaneEvent est introuvable",
      TRAILER_NUMBER_DOES_NOT_MATCH: "Le numéro de remorque ne correspond pas",
      TRAILER_NUMBER_DOES_NOT_MATCH_WITH_RECORD:
        "Le numéro de remorque ne correspond pas à celui du dossier",
      TRAILER_NUMBER_IS_NOT_AVAILABLE: "Le numéro de remorque n’est pas disponible",
      TRAILER_NUMBER_MISSING:
        "Le numéro de remorque est manquant ou ne correspond pas à celui du dossier",
      TRAILER_NUMBER_NOT_PRESENT:
        "Le numéro de remorque ne figure pas dans le rendez-vous",
      TRAILER_NUMBER_SHOULD_NOT_EXIST:
        "Le numéro de remorque ne devrait pas exister dans le dossier",
      UNABLE_TO_VALIDATE_TEMPERATURE: "Impossible de valider la température",
      UNSUPPORTED_APPOINTMENT_TYPE: "Type de rendez-vous non pris en charge",
    },
    LACTALIS: {
      APPOINTMENT_DOES_NOT_EXIST: "Le rendez-vous n’existe pas",
      OFF_HOURS_OUTBOUND_TRAILER:
        "En dehors des heures d’ouverture, les véhicules sortants avec remorque doivent utiliser l’interphone",
      OUTBOUND_TRAFFIC_WORKING_HOURS:
        "Le trafic sortant pendant les heures de travail doit utiliser l’interphone",
      YMS_CHECKIN_FAILED:
        "Échec de l’enregistrement dans le système YMS. Veuillez contacter l’opérateur de la barrière.",
    },
    LOBLAW: {
      ENTRY_APPROVED:
        "Entrée approuvée. Veuillez vous rendre à l’aire de stationnement {{MESSAGE}}",
      INVALID_INFORMATION: "Informations non valides",
      PROCEED_TO_DISPATCH:
        "{{MESSAGE}} Veuillez vous rendre au bureau de répartition pour plus de détails",
      SEE_YOU_NEXT_TIME: "{{MESSAGE}} À la prochaine fois",
    },
    PORTCITY: {
      AFTER_HOURS_ENTRY:
        "Pour entrer en dehors des heures d’ouverture, veuillez utiliser le clavier numérique situé dans la voie centrale. Code fourni par votre responsable de répartition",
      BOOKING_NUMBER_PROVIDED_NOT_VALID:
        "Le numéro de réservation fourni n’est pas valide",
      INVALID_EAIGLE_APPOINTMENT_RECORD: "Rendez-vous Eaigle non valide",
      INVALID_PROFILE_OR_EXPIRED_CREDENTIAL: "Profil non valide ou identifiant expiré",
      IT_IS_NOT_AN_OUTBOUND_BOBTAIL:
        "Ce véhicule n’est pas un camion sans remorque sortant",
      IT_IS_NOT_A_BOBTAIL: "Ce véhicule n’est pas un camion sans remorque",
      LOADID_PROVIDED_IS_NOT_VALID: "L’identifiant de chargement fourni n’est pas valide",
      NO_BOOKING_NUMBER_PROVIDED: "Aucun numéro de réservation fourni",
      NO_INPROGRESS_CV_LANE_EVENT_FOUND: "Aucun InProgress CV LaneEvent trouvé",
      NO_LOADID_PROVIDED: "Aucun identifiant de chargement fourni",
      PICK_UP_BOL: "{{MESSAGE}} Récupérer le connaissement à la porte 25",
      PLEASE_CONTACT_SECURITY_TO_OPEN_GATE:
        "Veuillez contacter la sécurité pour ouvrir la barrière",
      UNSUPPORTED_APPOINTMENT_TYPE: "Type de rendez-vous non pris en charge",
      UNSUPPORTED_OPERATION_TYPE: "Type d’opération non pris en charge",
    },
    TRIMAC: {
      NOT_A_VALID_REQUEST: "Demande non valide",
    },
  },
  CARRIER: {
    SCAC_AND_NAME: "{{SCAC}} ({{NAME}})",
    NAME_AND_SCAC: "{{NAME}} ({{SCAC}})",
  },
  CATEGORY: {
    ACTUAL_TEMPERATURE: "Température réelle",
    ACTUAL_TEMPERATURE_F: "Température réelle, °F",
    COMPANY: "Informations sur l’entreprise",
    EQUIPMENT_DETAILS: "Détails de l’équipement",
    LOAD_DETAILS: "Détails du chargement",
    PERSONAL: "Informations personnelles",
    PURPOSE_DETAILS: "Détails de l’objectif",
    SAFETY: "Sécurité",
    SET_TEMPERATURE: "Température définie",
    SET_TEMPERATURE_F: "Température définie, °F",
    SHIPPING_DETAILS: "Détails de l’expédition",
    SHIPPING_DETAILS_WITHOUT_VALIDATION: "Détails de l’expédition sans validation",
    SHIPPING_DETAILS_WITH_VALIDATION: "Détails de l’expédition avec validation",
    VEHICLE_EQUIPMENT_DETAILS: "Détails du véhicule / de l’équipement",
    VISIT_PURPOSE: "Objet de la visite",
  },
  COMMAND: {
    ADD_NEW_DRIVER: "Ajouter un nouveau chauffeur",
    APPROVE: "Approuver",
    BACK: "Retour",
    BACK_TO_EVENTS: "Retour aux événements",
    CHECK_IN: "Arrivée",
    CHECK_OUT: "Départ",
    CLEAR: "Effacer",
    CLICK_TO_EDIT: "Cliquez pour modifier",
    CLOSE: "Fermer",
    CLOSE_IMAGE_MODAL: "Fermer l’image modale",
    DELETE: "Supprimer",
    EDIT: "Modifier",
    LOGOUT: "Déconnexion",
    NEXT: "Suivant",
    OPEN_GATE: "Ouvrir la barrière",
    REJECT: "Refuser",
    RETURN: "Retourner",
    SELECT_END: "Sélectionnez Terminer",
    SELECT_START: "Sélectionnez Commencer",
    SSO_LOGIN: "Se connecter avec Azure AD",
    START_NEW_REGISTRATION: "Démarrer un nouvel enregistrement",
    SUBMIT: "Envoyer",
    TODAY: "Aujourd’hui",
    UPDATE: "Mettre à jour",
  },
  DAY: {
    "0": "Dim",
    "1": "Lun",
    "2": "Mar",
    "3": "Mer",
    "4": "Jeu",
    "5": "Ven",
    "6": "Sam",
  },
  ERROR: {
    VIDEO_NOT_SUPPORTED: "Votre navigateur ne prend pas en charge la balise vidéo.",
  },
  ERROR_MODAL: {
    INVALID_X: "Non valide {{TITLE}}",
  },
  EVENT_STATUS: {
    APPROVED: "approuvé",
    FAILURE: "échec",
    INPROGRESS: "en cours",
    REJECTED: "rejeté",
    SUCCESS: "réussi",
  },
  FAILURE_PAGE: {
    BODY: "Appuyez sur le bouton d’interphone de la borne",
    FAILURE: "Échec",
    HEADER: "Informations non vérifiées!",
    INTERCOM: "Interphone",
  },
  FILTER: {
    CARD: {
      EVENT_TYPE: "Type d’événement",
      STATUS: "Statut",
      TIME: "Heure",
      TRAILER_LOGO: "Logo de la remorque",
    },
    EVENT_TYPE: {
      JB_HUNT: "JB Hunt",
    },
    LOGO: {
      AB: "AB",
      CD: "CD",
      DH: "DH",
      EF: "EF",
    },
    STATUS: {
      CLEAN: "Propre",
      DIRTY: "Sale",
      EMPTY: "Vide",
      INBOUND: "Entrant",
      LOADED: "Chargé",
      OUTBOUND: "Sortant",
    },
    TIME: {
      LAST_24_HOURS: "L 24",
      LAST_MONTH: "L Mois",
      LAST_WEEK: "L Semaine",
      LAST_YEAR: "L Année",
      TODAY: "Aujourd’hui",
    },
  },
  FORM_INPUT: {
    COMMAND: {
      ENTER_SCAC: "Cliquez pour saisir manuellement le code SCAC",
      SELECT_SCAC: "Cliquez pour sélectionner parmi les codes SCAC disponibles",
      SHOW_LESS: "Afficher moins",
      SHOW_MORE: "Afficher plus",
    },
    FIELD_IS_REQUIRED: "Ce champ est obligatoire",
    NO_MATCHES: "Aucune correspondance trouvée",
    REQUIRED_LABEL: "{{TEXT}}*",
    SELECT: "Rechercher ou sélectionner...",
    SELECT_CARRIER: "Rechercher ou sélectionner un transporteur...",
    SELECT_DATE: "Sélectionner la date",
    SELECT_OPTIONS: "Sélectionner les options...",
    TRUNCATED: "{{TEXT}}...",
  },
  FORM_PAGE: {
    COMMAND: {
      NEXT: "Suivant",
      SUBMIT: "Envoyer",
    },
    ERROR: {
      UNABLE_TO_SUBMIT:
        "Impossible d’envoyer le formulaire. Veuillez réessayer plus tard.",
    },
    VALIDATING: "Validation en cours...",
  },
  HINT: {
    EDIT_SEAL_NUMBER: "* Modifiez le numéro de scellé renseigné si nécessaire.",
    LOAD_ID_8_DIGITS:
      "Votre identifiant de chargement est un numéro à 8 chiffres commençant par 4.",
    SCAC_NOT_LISTED_CPU9:
      "Si votre code SCAC ne figure pas dans la liste, veuillez saisir CPU9.",
  },
  IDCAPTURE: {
    CAMERA_ERROR: {
      BODY: "Nous n’avons pas pu accéder à votre caméra. Veuillez vérifier les autorisations et réessayer.",
      HEADER: "Erreur d’accès à la caméra",
    },
    COMMAND: {
      CAPTURE: "Capture de pièce d’identité",
      CAPTURING: "Capture en cours...",
      CHANGE_TYPE: "Modifier le type de pièce d’identité",
      DONE: "Terminé",
      RETAKE_PHOTOS: "Reprendre les photos",
      SUBMIT: "Envoyer",
      SWITCH_CAMERA: "Changer de caméra",
      TRY_AGAIN: "Réessayer",
      TRY_BACK: "Essayer la caméra arrière",
      TRY_FRONT: "Essayer la caméra avant",
    },
    EMPLOYEE_ID_BACK: "Carte d’identité d’employé (verso)",
    EMPLOYEE_ID_BACK_ALT: "Verso de la carte d’identité d’employé",
    EMPLOYEE_ID_FRONT: "Carte d’identité d’employé (recto)",
    EMPLOYEE_ID_FRONT_ALT: "Recto de la carte d’identité d’employé",
    ERROR: {
      EXPIRED:
        "La pièce d’identité a expiré. Veuillez fournir une pièce d’identité valide.",
      GENERIC: "Une erreur s’est produite",
      NO_CAMERA:
        "Aucune caméra accessible. Veuillez connecter votre caméra ou essayer un autre navigateur.",
      NO_SWITCH:
        "Il n’est pas possible de changer de caméra car un seul appareil vidéo est accessible.",
      PERMISSION_DENIED:
        "Autorisation refusée. Veuillez actualiser la page et autoriser l’accès à la caméra.",
      UNREADABLE: "Impossible de lire les informations d’identification.",
      UNSUPPORTED: "Canvas n’est pas pris en charge.",
      UPLOAD_FAILED:
        "Échec du téléchargement des images de la carte d’identité d’employé",
      UPLOAD_FAILED_TRY_AGAIN:
        "Échec du téléchargement des images de la carte d’identité d’employé. Veuillez réessayer.",
      VERIFY_FAILED_TRY_AGAIN: "Échec de la vérification d’identité. Veuillez réessayer.",
    },
    ID_INFORMATION: "Informations d’identification",
    ID_NOT_VERIFIED_MESSAGE:
      "Nous n’avons pas pu vérifier entièrement votre identité. Veuillez vérifier les informations ci-dessous.",
    ID_NOT_VERIFIED_STATUS: "Problèmes de vérification de l’identité",
    ID_VERIFIED_MESSAGE: "Votre identité a été vérifiée avec succès.",
    ID_VERIFIED_STATUS: "Vérification de l’identité réussie",
    INSTRUCTIONS: {
      DRIVERS_LICENSE:
        "Placez votre permis de conduire dans le cadre et assurez-vous que l’éclairage est suffisant.",
      EMPLOYEE_ID_BACK:
        "Placez maintenant le VERSO de votre carte d’identité d’employé dans le cadre.",
      EMPLOYEE_ID_FRONT:
        "Placez le RECTO de votre carte d’identité d’employé dans le cadre.",
    },
    PROCESSING: "Traitement en cours...",
    SELECT_TYPE: "Sélectionnez le type de pièce d’identité",
    TYPE: {
      DRIVERS_LICENSE: "Permis de conduire",
      EMPLOYEE_ID: "Carte d’identité d’employé",
    },
  },
  IMAGE_PREVIEW: {
    CAPTURED_ID: "Capture de la pièce d’identité",
    COMMAND: {
      RETAKE: "Reprendre",
      SUBMIT: "Envoyer",
    },
    PLEASE_WAIT: "Veuillez patienter pendant que nous vérifions vos informations.",
    PROCESSING_ID: "Traitement de votre pièce d’identité...",
    SUBMITTING: "Envoi...",
    TIP: "Assurez-vous que l’image est claire et lisible.",
  },
  KIOSK: {
    COMMAND: {
      ENTER: "Entrer",
      REGISTER_NOW: "S’enregistrer maintenant",
    },
    ERROR: {
      CONNECTION_CLOSED: "Connexion fermée",
      CONNECTION_ERROR: "Erreur de connexion",
      ENTRY_TYPE_INVALID: "Le type d’entrée {{TYPE}} n’est pas valide",
      ENTRY_TYPE_MISSING: "Le type d’entrée est manquant",
      FAILED_TO_CONNECT: "Échec d’établissement de la connexion",
      INFORMATION_NOT_VERIFIED_USE_INTERCOM:
        "Informations non vérifiées! Utiliser l’interphone",
      INTERACTION_TYPE_INVALID: "Le type d’interaction {{TYPE}} n’est pas valide.",
      INTERACTION_TYPE_MISSING: "Type d’interaction manquant",
      INTERMITTENT_CONNECTION:
        "Erreur de connexion intermittente. Si le problème persiste, veuillez contacter l’assistance EAIGLE au 1-888-771-1584.",
      MISSING_REQUIRED_INFO: "Informations obligatoires manquantes",
      PROCESSING_ERROR:
        "Erreur lors du traitement de votre demande. Utiliser l’interphone",
      VALIDATION_FAILED: "Échec du processus de validation",
      VALIDATION_TIMEOUT: "Délai de validation expiré",
    },
    FOOTER: {
      NOT_REGISTERED: "Vous n’êtes pas inscrit?",
    },
    GATE_OPEN: "Barrière ouverte",
    INFORMATION_VERIFIED: "Informations vérifiées!",
    INVALID_URL_PARAMETERS: "Paramètres URL non valides",
    KEY: {
      BACKSPACE: "Retour arrière",
      CLEAR: "Effacer",
      CLOSE: "Fermer",
    },
    KEY_PAD_INSTRUCTIONS: "Entrer le code OTP",
    PLEASE_ROTATE_LANDSCAPE: "Veuillez mettre votre appareil en mode paysage",
    PLEASE_WAIT_X: "Veuillez patienter. {{TEXT}}",
    PRE_REGISTERED: "Vous êtes pré-inscrit?",
    PROCEED_TO_EXIT: "Veuillez vous diriger vers la sortie.",
    PROCEED_TO_ZONE: "Rendez-vous dans la zone qui vous a été attribuée.",
    REDIRECTING: "Redirection en cours...",
    SCAN_QR_CODE:
      "Présentez votre code QR <br/> de pré-enregistrement à la borne <br/> pour qu’il soit scanné.",
    SECONDS_REMAINING: "{{N}} secondes restantes",
    TROUBLE_SCANNING_QR_CODE:
      "Problème lors du balayage du code QR - Appuyez ici pour saisir manuellement le code de rendez-vous",
    VALIDATION: {
      PERSON_NAME: "Lettres et espaces uniquement",
      PHONE_NUMBER: "Par exemple, 1234567890",
    },
    VERIFYING_INFORMATION: "Vérification des informations...",
    VIDEO_NOT_AVAILABLE: "Vidéo en direct non disponible",
    WAIT_VERIFY_INFO: "Veuillez patienter pendant que nous vérifions vos informations.",
    WAIT_VERIFY_QR: "Veuillez patienter pendant la vérification du code QR",
  },
  LABEL: {
    APPROVED: "Approuvé",
    AREA: "Zone",
    CARRIER: "Transporteur",
    CHECK_ICON: "Icône de vérification",
    CHECK_IN_TIME: "Heure d’arrivée",
    CHECK_OUT_TIME: "Heure de départ",
    DETENTION_TIME: "Temps d’immobilisation",
    INDICATORS: "Indicateurs",
    DETENTION_TIME_HOURS: "Temps d’immobilisation (heures)",
    DRIVERS: "Chauffeurs",
    DURATION: "Durée",
    ERROR_ICON: "Icône d’erreur",
    FIRST_NAME_LAST_NAME: "{{FIRST}} {{LAST}}",
    FROM_DATE_TIME_TZ: "À partir de : {{DATE_TIME_TZ}}",
    GATE_LOG: "Historique de la barrière",
    GATE_OPEN: "Ouverture de la barrière",
    LOCATION: "Emplacement",
    NOT_APPLICABLE: "N/A",
    OPENING: "Ouverture...",
    REGISTRATION: "Enregistrement",
    ROW: "Rangée",
    SECTION_N: "{{SECTION}} {{N}}",
    SPOT: "Spot",
    STEP_N: "Étape {{N}}",
    TANKER: "Camion-citerne",
    TIME: "Heure",
    TIME_STAMP: "Horodatage",
    TOTAL_RECORDS_N: "Nombre total d’enregistrements : {{N}}",
    TO_DATE_TIME_TZ: "À : {{DATE_TIME_TZ}}",
    UNIT_1: "Unité 1",
    UNIT_HISTORY: "Historique de l’unité",
    UNIT_ID: "Identifiant de l’unité",
    UNIT_TYPE: "Type d’unité",
    YARD_CHECK: "Contrôle du parc",
    YARD_INVENTORY: "Inventaire du parc",
    ZOOMABLE_TYPE: "Zoomable {{TYPE}}",
  },
  MONTH: {
    "1": "Janvier",
    "2": "Février",
    "3": "Mars",
    "4": "Avril",
    "5": "Mai",
    "6": "Juin",
    "7": "Juillet",
    "8": "Août",
    "9": "Septembre",
    "10": "Octobre",
    "11": "Novembre",
    "12": "Décembre",
  },
  NAVBAR: {
    COMMAND: {
      PREVIOUS: "Précédent",
    },
    DRIVER_REGISTRATION: "Enregistrement du chauffeur",
    LOGO: "Logo",
  },
  PASSCODE_PAGE: {
    COMMAND: {
      VERIFY: "Vérifier",
    },
    ENTER_PASSCODE: "Entrer le code d’accès",
    ERROR: {
      INVALID_PASSCODE: "Code d’accès non valide",
    },
  },
  PLACEHOLDER: {
    ACTUAL_TEMPERATURE_F: "Température réelle (°F)",
    BOL_OR_PO_NUMBERS: "Connaissement(s) / Bon(s) de commande",
    BOOKING_NUMBER: "Numéro de réservation",
    CARRIER: "Transporteur",
    CARRIER_NAME_PARENT_SCAC: "Nom du transporteur (code SCAC parent)",
    CARRIER_SCAC: "Entrer le code SCAC du transporteur",
    COMPANY_NAME: "Nom de la société",
    CURRENT_TEMPERATURE_F: "Température actuelle (°F)",
    CVIP_DATE: "Date CVIP",
    DRIVER_FIRST_NAME: "Prénom du chauffeur",
    DRIVER_LAST_NAME: "Nom de famille du chauffeur",
    DRIVER_NAME: "Nom du chauffeur",
    DRIVER_TYPE: "Type de chauffeur",
    DUNNAGE: "Fardage",
    EMAIL: "Courriel",
    EMAIL_ADDRESS: "Adresse courriel",
    ENTRY_TYPE_REASON: "Type d’entrée (motif de la visite)",
    EQUIPMENT_LENGTH: "Longueur de l’équipement",
    EQUIPMENT_LOADED_STATUS: "Statut de chargement de l’équipement",
    EQUIPMENT_TYPE: "Type d’équipement",
    FIRST_NAME: "Prénom",
    FUEL_LEVEL: "Niveau de carburant",
    ID_VALIDATION: "Validation d’identifiant",
    I_AGREE: "J’approuve",
    LAST_NAME: "Nom de famille",
    LOAD_ID: "Identifiant du chargement",
    LOAD_ID_NUMBER: "Numéro d’identifiant du chargement",
    OUTBOUND_BOL: "Connaissement sortant",
    PHONE_NUMBER: "Numéro de téléphone",
    PO_NUMBER: "Numéro de bon de commande",
    PO_NUMBER_OR_LOAD_ID:
      "Numéro de bon de commande, code ASN ou identifiant de chargement / de référence",
    PPE_DOCK_SAFETY: "EPI et sécurité des quais de chargement",
    PPE_DOCK_SAFETY_ASSISTANCE:
      "Si vous avez besoin d’aide concernant la sécurité des quais de chargement, ou si vous avez des questions concernant les EPI, veuillez vous adresser au personnel désigné au poste de contrôle. \n\nMerci",
    PPE_DOCK_SAFETY_COMPLIANCE:
      "En cliquant sur OUI, vous acceptez de vous conformer à l’ensemble des lois applicables, ainsi qu’à nos propres politiques. Toute utilisation, modification ou distribution non autorisée est interdite. Nous ne pourrons être tenus responsables des dommages éventuels. Pour en savoir plus, consultez notre politique de confidentialité et nos conditions générales.\n\nLe non-respect des exigences en matière d’EPI ou de sécurité des quais de chargement peut entraîner des amendes. Si vous avez besoin d’aide concernant la sécurité des quais de chargement, ou si vous avez des questions concernant les EPI, veuillez vous adresser au personnel désigné au poste de contrôle.",
    REASON_FOR_ENTRY: "Motif de l’entrée",
    REEFER_FUEL_LEVEL: "Niveau de carburant du conteneur réfrigéré",
    REEFER_ON: "Conteneur réfrigéré activé/désactivé",
    SEAL_NUMBER: "Numéro de scellé",
    SEARCH_CARRIER: "Rechercher un transporteur...",
    SELECT_FACILITY: "Sélectionner un établissement...",
    SELECT_X: "Sélectionner {{X}}",
    SIGNATURE: "Signature",
    TEMPERATURE_F: "Température (°F)",
    TRACTOR_CARRIER_NAME: "Nom du transporteur sur le tracteur",
    TRACTOR_NUMBER: "Numéro de tracteur",
    TRAILER_CARRIER_NAME: "Nom du transporteur sur la remorque",
    TRAILER_MIDDLE: "Milieu",
    TRAILER_NOSE: "Avant",
    TRAILER_NUMBER: "Numéro de remorque",
    TRAILER_TAIL: "Arrière",
    TRAILER_TYPE: "Type de remorque",
    VALIDATION_PERIOD: "Période de validation",
  },
  QUESTION: {
    ACTUAL_TEMPERATURE_F: "Température réelle, °F",
    APPOINTMENT_DETAILS: "Détails du rendez-vous",
    COMPANY_INFO: "Informations sur l’entreprise",
    CONFIRM_SEAL_AND_TRAILER_NUMBER:
      "Vérifiez que le scellé est intact et que le numéro de la remorque est correct",
    CONFIRM_TRAILER_CONDITION:
      "Vérifiez que la remorque est exempte de débris, que les tandems sont reculés, et que le conteneur réfrigéré fonctionne.",
    DRIVER_NAME: "Entrez le nom du chauffeur",
    DRIVER_TYPE: "Type de chauffeur",
    ENTRY_PURPOSE: "Sélectionnez le motif de l’entrée",
    ENTRY_TYPE: "Choisissez votre type d’entrée",
    EQUIPMENT_DETAILS: "Détails de l’équipement",
    GENERIC: "Remplissez les informations",
    LOAD_DETAILS: "Détails du chargement",
    LOAD_TYPE: "Sélectionnez le type de chargement",
    PERSONAL_INFO: "Informations personnelles",
    PPE_DOCK_SAFETY: "EPI et sécurité des quais de chargement",
    SET_TEMPERATURE_F: "Température définie, °F",
    SHIPPING_DETAILS: "Détails de l’expédition",
    VEHICLE_DETAILS: "Détails du véhicule",
    VISIT_TYPE: "Choisissez votre type de visite",
    WAIVER: "Décharge",
  },
  STATUS: {
    ACTIVE: "Actif",
    EXPIRED: "Expiré",
    EXPIRING_SOON: "Expiration prochaine",
  },
  SUCCESS_PAGE: {
    COMMAND: {
      DOWNLOAD: "Télécharger",
      EMAIL: "Courriel",
      HOME: "Accueil",
      MESSAGE: "Message",
      START_OVER: "Recommencer",
    },
    DRIVER_CHECK_IN_SUCCESS: "Entrée initialisée avec succès",
    DRIVER_CHECK_OUT_SUCCESS: "Sortie initialisée avec succès",
    GENERATING_QR_CODE: "Génération du code QR en cours!",
    PLEASE_CHECK_DASHBOARD: "Vérifiez l’état d’avancement sur le tableau de bord AVAC",
    PLEASE_SCAN_CODE: "Veuillez scanner votre code QR à la borne.",
    PLEASE_WAIT: "Veuillez patienter...",
    QR_CODE_GENERATED: "Code QR généré!",
  },
  SUGGESTION: {
    PO_NUMBER_OR_LOAD_ID:
      "Remplissez le champ « Numéro de bon de commande » ou « Identifiant de chargement »",
  },
  TITLE: {
    CARRIER: "Transporteur",
    CATEGORY: "Catégorie",
    COMPANY_NAME: "Nom de la société",
    EMAIL_ADDRESS: "Adresse courriel",
    ENTRY_SUB_TYPE: "Sous-type d’entrée",
    ENTRY_TYPE: "Type d’entrée",
    FIRST_NAME: "Prénom",
    LAST_NAME: "Nom de famille",
    PHONE_NUMBER: "Numéro de téléphone",
    REASON_FOR_ENTRY: "Motif de l’entrée",
    REFERENCE_NUMBER: "Numéro de référence",
    SEAL_NUMBER: "Numéro de scellé",
    SIGNATURE: "Signature",
    TEMPERATURE: "Température",
    TRAILER_NUMBER: "Numéro de remorque",
    VALIDATION_PERIOD: "Période de validation",
  },
  TOOLTIP: {
    ADD: "Ajouter",
    ARROW: "flèche",
    COMPANY_LOGO: "Logo de l’entreprise",
    DOWNLOAD: "télécharger",
    LOGO: "Logo",
    MENU: "menu",
    SORT_ASC: "trier par ordre croissant",
    SORT_DESC: "trier par ordre décroissant",
  },
  VALIDATION: {
    EMAIL_ADDRESS: "Veuillez saisir une adresse courriel valide",
    ERROR: {
      BOL_VALIDATION_FAILED: "Échec de la validation du numéro de référence.",
      FUEL_VALIDATION_FAILED:
        "Échec de l’obtention des statistiques du conteneur réfrigéré",
      INVALID_BOOKING_NUMBER: "Numéro de réservation non valide",
      INVALID_FACILITY: "Établissement non valide",
      INVALID_LOAD_ID: "Identifiant de chargement non valide",
      LOAD_ID_VALIDATION_FAILED:
        "Échec de la validation du numéro d’identifiant du chargement",
      PO_VALIDATION_FAILED:
        "Bon de commande non valide. Réessayez ou adressez-vous au commis aux réceptions.",
      TRAILER_VALIDATION_FAILED: "Échec de la validation des détails de la remorque",
    },
    FLOAT: "Veuillez saisir des nombres valides (par exemple 123 ou 123,45)",
    NUMERIC: "Veuillez saisir uniquement des nombres",
    PERSON_NAME: "Ne doit contenir que des lettres et des espaces",
    PHONE_NUMBER: "Format de numéro de téléphone incorrect",
    PO_NUMBER_OR_LOAD_ID:
      "Veuillez fournir le numéro de bon de commande ou l’identifiant de chargement",
    TEMPERATURE_FROM_N20F_TO_P100F:
      "La température doit être comprise entre -20 et 100 °F",
    VALIDATING_REFERENCE_NUMBER: "Validation du numéro de référence",
    VALIDATING_TRAILER_DETAILS: "Validation des détails de la remorque",
  },
} as const;
